import * as React from "react";
const SvgSeparator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 2, height: 18, viewBox: "0 0 2 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L0.999999 17", stroke: "#CACCD3", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgSeparator;
